import { Dispatch } from "redux";

import {
  GeneralDispatchType,
  SET_BEFORE_INSTALL_EVENT,
  SET_LANGUAGE,
  SET_THEME,
} from "./GeneralActionType";

export const SetTheme =
  (theme: string) => (dispatch: Dispatch<GeneralDispatchType>) => {
    try {
      dispatch({
        type: SET_THEME,
        payload: {
          theme: theme,
        },
      });
    } catch (e) {
      dispatch({
        type: SET_THEME,
        payload: {
          theme: "dark",
        },
      });
    }
  };

export const SetLanguage =
  (lang: string) => (dispatch: Dispatch<GeneralDispatchType>) => {
    try {
      dispatch({
        type: SET_LANGUAGE,
        payload: {
          language: lang,
        },
      });
    } catch (e) {
      dispatch({
        type: SET_LANGUAGE,
        payload: {
          language: "fa",
        },
      });
    }
  };

export const SetBeforeInstallEvent =
  (event: Event) => (dispatch: Dispatch<GeneralDispatchType>) => {
    try {
      dispatch({
        type: SET_BEFORE_INSTALL_EVENT,
        payload: {
          beforeInstallEvent: event,
        },
      });
    } catch (e) {
      dispatch({
        type: SET_BEFORE_INSTALL_EVENT,
        payload: {
          beforeInstallEvent: undefined,
        },
      });
    }
  };
